import React, { useEffect, useState } from "react";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import "./acTypesChartPage.css";

const AcTypesChartPage = ({ onLoadComplete }) => {
  const [chart, setChart] = useState([]);
  const [loading, setLoading] = useState(true);

  const baseUrl = `https://api.generalhome.sa/api/Reports/GetACTypeRequestCounts`;

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const maintenanceAreaIdsString =
          localStorage.getItem("MaintenanceAreaIds");
        const maintainceAreaId = maintenanceAreaIdsString
          ? maintenanceAreaIdsString.split(",").map(Number)
          : [];
        const response = await axios.post(
          baseUrl,
          {
            maintenanceAreaIds: maintainceAreaId,
            AcTypeNumber: 0, // Always fetch all types
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        setChart(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
        if (onLoadComplete) onLoadComplete();
      }
    };
    fetchInfo();
  }, [baseUrl]);

  if (loading) {
    return (
      <div className="loading-container">
        <ClipLoader color="#00b1ff" size={50} />
      </div>
    );
  }

  // Calculate total requests for summary
  const totalRequests = chart.reduce(
    (total, item) => total + item.RequestCount,
    0
  );

  return (
    <div className="ac-types-page">
      <div className="ac-types-container">
        <div className="ac-types-header">
          <h2>إحصائيات أنواع المكيفات</h2>
          <p>توزيع الطلبات حسب نوع المكيف</p>
        </div>

        <div className="ac-types-grid">
          {chart.map((x, index) => (
            <div key={x.ACTypeId || x.ACTypeName} className="ac-type-card">
              <div className="ac-type-content">
                <div className="ac-icon">❄️</div>
                <div className="ac-type-info">
                  <h3 className="ac-type-name">{x.ACTypeName}</h3>
                  <div className="ac-type-count">{x.RequestCount} طلب</div>
                </div>
              </div>
              <div className="progress-container">
                <div
                  className="progress-bar"
                  style={{
                    width: `${(x.RequestCount / totalRequests) * 100}%`,
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        <div className="ac-types-summary">
          <div className="summary-item">
            <span className="summary-label">إجمالي أنواع المكيفات:</span>
            <span className="summary-value">{chart.length}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">إجمالي الطلبات:</span>
            <span className="summary-value">{totalRequests}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcTypesChartPage;
